import { create } from "zustand";
import type { TrackingState } from "../types/tracking";

export const useTrackingStore = create<TrackingState>((set) => ({
	selectedVehicleId: null,
	vehicleFilterId: null,
	isVehiclesModalOpen: false,
	routeCoords: [],
	routeStartMarker: null,
	routeEndMarker: null,
	positionMarkers: [],
	selectedPositionInfo: null,
	selectedPositionIndex: null,

	setSelectedVehicleId: (id) => set({ selectedVehicleId: id }),
	setVehicleFilterId: (id) => set({ vehicleFilterId: id }),
	openVehiclesModal: () => set({ isVehiclesModalOpen: true }),
	closeVehiclesModal: () => set({ isVehiclesModalOpen: false }),
	setRouteCoords: (coords) => set({ routeCoords: coords }),
	setRouteStartMarker: (marker) => set({ routeStartMarker: marker }),
	setRouteEndMarker: (marker) => set({ routeEndMarker: marker }),
	setPositionMarkers: (markers) => set({ positionMarkers: markers }),
	setSelectedPositionInfo: (info) => set({ selectedPositionInfo: info }),
	setSelectedPositionIndex: (index) => set({ selectedPositionIndex: index }),
	clearRoute: () =>
		set({
			routeCoords: [],
			routeStartMarker: null,
			routeEndMarker: null,
			positionMarkers: [],
			selectedPositionInfo: null,
			selectedPositionIndex: null,
		}),
}));
